import React, { useState } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { MdOutlineSearch } from "react-icons/md";
import './Mi.css';

const SearchVecino = ({dataI,onValorSeleccionadoChange}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [selectedResult, setSelectedResult] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

 /* useEffect(() => {
    setSearchTerm(' ');
  }, [dataI]);
*/
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchTerm(value);

    let count = 0;

    const filteredResults = dataI.filter((suggestion) => {
        const strproductName = suggestion.nombreEquipo || '';
        const strproductCode = suggestion.codigo || '';
        const strproductMarca = suggestion.marca || '';
        const strproductModelo = suggestion.modelo || '';

        const keep = count < 40
           && (strproductName.toLowerCase().includes(value.toLowerCase())
              || strproductCode.toLowerCase().includes(value.toLowerCase())
              || strproductMarca.toLowerCase().includes(value.toLowerCase())
              || strproductModelo.toLowerCase().includes(value.toLowerCase()));
              return keep;
      });

   setResults(filteredResults);
  };

  const handleSelectResult = (result) => {
    onValorSeleccionadoChange(result._id);
    setResults([]);
    setSearchTerm('');
    setModalOpen(false);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="search-component">
      <button type="button" className="bg-green-500 hover:bg-green-700 flex-nowrap text-white font-bold py-2 text-xs px-2 rounded mb-4" onClick={openModal}>
      <div className="grid grid-cols-3 md:grid-cols-3 gap-4" >
        <div className="flex flex-col">
          Buscar
        </div> 
        <div className="flex flex-col">
          ... 
        </div> 
      </div>
      </button>
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal">
          <button
                type="button"
                onClick={closeModal}
                style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
                className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
              >
              <MdOutlineCancel />
            </button>

            <div className="modal-content">
              <input
              className=" flex-1 text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300 w-full"
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearch}
              />
              {results.length > 0 && (
                <ul>
                  {results.map((result) => (
                    <li  className=" flex-1 text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300" key={result._id} onClick={() => handleSelectResult(result)}>
                     <div className="grid grid-cols-4 md:grid-cols-4 gap-4" >
                        <div className="flex flex-col">
                        {result.codigo}
                        </div>
                        <div className="flex flex-col">
                        {result.nombreEquipo}
                        </div>
                        <div className="flex flex-col">
                        {result.marca}
                        </div>
                        <div className="flex flex-col">
                        {result.modelo}
                        </div>
                     </div>
                    </li>
                  ))}
                </ul>
              )}

              {selectedResult && <p>Seleccionado: {selectedResult}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchVecino;
